import request from '@/config/axios'

export interface SpuDistConfigVO {
  spuId?: number | string
  areaAgentEnabled?: boolean
  cashbackEnabled?: boolean
  cashbackTotalPrice?: number
  cashbackDailyRate?: number
}

/** 查询商品分销配置（无记录时后端返回全关） */
export const getSpuDistConfig = (spuId: number | string) => {
  return request.get({ url: '/distribution/spu-config/get', params: { spuId } })
}

/** 保存商品分销配置（upsert；关闭返现时后端清空金额与比例） */
export const saveSpuDistConfig = (data: SpuDistConfigVO) => {
  return request.post({ url: '/distribution/spu-config/save', data })
}
